<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="sAPShipmentInvoices/CXGXQuantityJOIN">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="发货日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.invoiceTime"
                  value-format="yyyy-MM-dd"
                  type="date"
                  style="width: 150px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="发货单状态">
            <el-select v-model.trim="filter.workflowStatus" clearable placeholder="请选择">
              <el-option
                  v-for="item in constants.shipmentInvoiceStatus.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="Column0" width="100" align="center" label="发货日期"/>
      <el-table-column prop="Column1" width="100" align="center" label="料齐未出料"/>
      <el-table-column prop="Column2" width="100" align="center" label="已出料未包装"/>
      <el-table-column prop="Column3" width="100" align="center" label="已包装未发运"/>
      <el-table-column prop="Column4" align="center" label="缺料"/>
      <el-table-column prop="Column5" align="center" label="缺控制柜"/>
      <el-table-column prop="Column6" align="center" label="缺操纵"/>
      <el-table-column prop="Column7" align="center" label="缺外招"/>
      <el-table-column prop="Column8" align="center" label="缺轿顶"/>
      <el-table-column prop="Column9" align="center" label="缺微机板"/>
      <el-table-column prop="Column10" align="center" label="缺一体机"/>
      <el-table-column prop="Column11" align="center" label="缺捡配单A"/>
      <el-table-column prop="Column12" align="center" label="缺线缆"/>
      <el-table-column prop="Column13" align="center" label="缺204"/>
      <el-table-column prop="Column14" align="center" label="缺电阻箱"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constants from "../../util/constants";

  export default {
    name: "ShipmentInvoiceCountList",
    components: {VmTable,VmSearch},
    data() {
      return {
        constants,
        filter: {
          invoiceTime: "",
          endInvoiceTime: "",
          workflowStatus: "已打印下发",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
